/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

import SEOImage from '../assets/images/paystack_docs_seo_image.jpg';

function Seo({ description, lang, meta, title }) {
	const { site, pstkType } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author
						siteUrl
						keywords
						featuredImage
					}
				}
				pstkType {
					branch
				}
			}
		`
	);

	// added keywords and siteUrl to query and meta

	const metaDescription = description || site.siteMetadata.description;

	const image = SEOImage

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			titleTemplate={`%s | ${site.siteMetadata.title}`}
			meta={[
				{
					name: `description`,
					content: metaDescription,
				},
				{
					name: "keywords",
					content: site.siteMetadata.keywords.join(","),
				},
				{
					property: `og:title`,
					content: title,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					property: `og:image`,
					content: `${site.siteMetadata.siteUrl.replace('/docs', '')}${image}`,
				},
				{
					name: `og:image:width`,
					content: `1200`,
				},
				{
					name: `og:image:height`,
					content: `631`,
				},
				{
					name: `twitter:card`,
					content: `summary_large_image`,
				},
				{
					name: `twitter:creator`,
					content: `@paystack`,
				},
				{
					name: `twitter:title`,
					content: title,
				},
				{
					name: `twitter:image`,
					content: `${site.siteMetadata.siteUrl.replace('/docs', '')}${image}`,
				},
				{
					name: `twitter:image:alt`,
					content: `An image of the Paystack Documentation logo - four blue stripes, 3 long and 1 short - in the shape of a P, with a doc text, against a dark blue (almost black) background`,
				},
				{
					name: `twitter:image:width`,
					content: `1200`,
				},
				{
					name: `twitter:image:height`,
					content: `631`,
				},
				{
					name: `twitter:description`,
					content: metaDescription,
				},
				{
					name: 'robots',
					content: `${["main", "master"].includes(pstkType.branch) ? "index, follow" : "noindex, nofollow"}`
				}
			].concat(meta)}
		/>
	);
}

Seo.defaultProps = {
	lang: `en`,
	meta: [],
	description: ``,
};

Seo.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired
};

export default Seo;
